import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "common/api/BaseQuery";
import {
  ConfirmPasswordAddEditJson,
  CustomerAddressCollectionJson,
  CustomerJson,
  CustomerJsonAddEdit,
  CustomerRankTypeCollectionJson,
  CustomerRankTypeFilters,
  CustomerUsernameAddEditJson,
  Event,
  EventFilters,
  FilterCustomerAddress,
  PasswordAddEditJson,
  Rank,
  SenderCustomerAddEditJson,
  VerifyCustomerAddEditJson,
} from "../types/customer.type";
import CustomerModel from "common/models/CustomerModel";
import Nteam from "common/constants/Nteam";
import { Jwt } from "common/types/Api";

type Error = {
  status:
    | number
    | "FETCH_ERROR"
    | "PARSING_ERROR"
    | "TIMEOUT_ERROR"
    | "CUSTOM_ERROR";
  errors: string[];
};
export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    // Api Public

    getCustomerDetailLogin: builder.query<
      CustomerJson,
      Pick<CustomerJson, "id">
    >({
      query: (params) => ({
        url: `customers/${params.id}`,
        method: "get",
        timeout: 7000,
      }),

      keepUnusedDataFor: 0,
    }),

    editCustomerLogin: builder.mutation<CustomerJson, CustomerJsonAddEdit>({
      query: (body: CustomerJsonAddEdit) => {
        return {
          url: `customers/${body.id}`,
          method: "put",
          // params: {},
          body: {
            ...body,
            company_id: Nteam.company_id,
            id: undefined,
          },
        };
      },
    }),

    changeCustomerPassword: builder.mutation<any, PasswordAddEditJson>({
      query: (body: PasswordAddEditJson) => {
        return {
          url: "/users/customer/changepassword",
          method: "put",
          // params: {},
          body: {
            ...body,
          },
        };
      },
    }),

    confirmPasswordCustomer: builder.mutation<any, ConfirmPasswordAddEditJson>({
      query: (body: ConfirmPasswordAddEditJson) => {
        return {
          url: "/users/customer/checkpassword",
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),

    verifyCustomer: builder.mutation<any, VerifyCustomerAddEditJson>({
      query: (body: VerifyCustomerAddEditJson) => {
        return {
          url: "/customers/verify",
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),

    senderCustomer: builder.mutation<any, SenderCustomerAddEditJson>({
      query: (body: SenderCustomerAddEditJson) => {
        return {
          url: "/customers/sender",
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),

    checkSenderCustomer: builder.mutation<any, SenderCustomerAddEditJson>({
      query: (body: SenderCustomerAddEditJson) => {
        return {
          url: "/customers/checksender",
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),

    changeUsernameCustomer: builder.mutation<any, CustomerUsernameAddEditJson>({
      query: (body: CustomerUsernameAddEditJson) => {
        return {
          url: "/customers/sender",
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),

    updateInfoCustomer: builder.mutation<CustomerJson, CustomerJsonAddEdit>({
      query: (body: CustomerJsonAddEdit) => {
        return {
          url: `/customers/${body.id}`,
          method: "post",
          body: {
            ...body,
          },
        };
      },
    }),

    getCustomerAddressList: builder.query<
      CustomerAddressCollectionJson,
      FilterCustomerAddress
    >({
      query: (params: FilterCustomerAddress & Jwt) => ({
        url: "customers/address/mine",
        params: {
          ...params,
        },
      }),
      keepUnusedDataFor: 3,
      transformResponse: (response: CustomerAddressCollectionJson, _) => {
        return response;
      },
      transformErrorResponse: (response, meta, arg) => {
        return response;
      },
    }),
    getRankType: builder.query<
      CustomerRankTypeCollectionJson,
      CustomerRankTypeFilters
    >({
      query: (params: CustomerRankTypeFilters) => ({
        url: "customers/ranktype",
        params: {
          ...params,
          id: params.id && params.id > 0 ? params.id : null,
        },
      }),
      keepUnusedDataFor: 3,
      // transformResponse: (response: CustomerAddressCollectionJson, _) => {
      //   return response;
      // },
      // transformErrorResponse: (response, meta, arg) => {
      //   return response;
      // },
    }),
    getEvent: builder.query<Event, EventFilters>({
      query(arg) {
        return {
          url: "events/checkeventrank",
          params: {
            ...arg,
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCustomerDetailLoginQuery,
  useEditCustomerLoginMutation,
  useChangeCustomerPasswordMutation,
  useConfirmPasswordCustomerMutation,
  useVerifyCustomerMutation,
  useSenderCustomerMutation,
  useUpdateInfoCustomerMutation,
  useChangeUsernameCustomerMutation,
  useCheckSenderCustomerMutation,
  useGetCustomerAddressListQuery,
  useGetRankTypeQuery,
  useGetEventQuery,
  endpoints,
} = customerApi;
